import ApiService from "./api.service";
const CriminalCaseInspectionService = {
  Get(id) {
    if (id == 0 || id == undefined || id == null || id == "") {
      return ApiService.get(`/CriminalCaseInspection/Get`);
    } else {
      return ApiService.get(`/CriminalCaseInspection/Get/${id}`);
    }
  },
  GetByInnOrPinfl(innOrPinfl) {
    return ApiService.get(
      `/CriminalCaseInspection/Get?innOrPinfl=${innOrPinfl}`
    );
  },
  Create(data) {
    return ApiService.post(`/CriminalCaseInspection/Create`, data);
  },
  Update(data) {
    return ApiService.post(`/CriminalCaseInspection/Update`, data);
  },
  Save(data) {
    if (data.id == 0 || data.id == undefined || data.id == null) {
      return ApiService.post(`/CriminalCaseInspection/Create`, data);
    } else {
      return ApiService.post(`/CriminalCaseInspection/Update`, data);
    }
  },
  GetSecurityInfo() {
    return ApiService.get(`/CriminalCaseInspection/GetSecurityInfo`);
  },
};
export default CriminalCaseInspectionService;
